import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/relatorio-viagem`

    return {
        index(queryParms = {}) {
            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        list(queryParms = {}) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        getMunicipios(queryParms = {}) {
            return repository.get(`${baseUrl}/municipio?${urlUtil.serialize(queryParms)}`)
        },
        getViagem(queryParms = {}) {
            return repository.get(`${baseUrl}/viagem?${urlUtil.serialize(queryParms)}`)
        }
    }
}